import AppStore from '~publish/legacy/composer/composer/stores/AppStore'
import type { ComposerProfile } from '~publish/legacy/composer/composer/stores/types'

type UseSelectedProfilesReturn = {
  isOmniboxEnabled: boolean | null
  selectedProfiles: ComposerProfile[]
  hasMultipleProfilesEnabled: boolean
  isApprovalRequired: boolean
  isSaveAndRequestApprovalDisabled: boolean
}

export const useSelectedProfiles = (): UseSelectedProfilesReturn => {
  const isOmniboxEnabled = AppStore.getIsOmniboxEnabled()
  const selectedProfiles = AppStore.getSelectedProfiles()
  const hasMultipleProfilesEnabled = selectedProfiles.length > 1
  const approvalRequiredFor = AppStore.requiresApprovalForSelectedProfiles()

  return {
    isOmniboxEnabled,
    selectedProfiles,
    hasMultipleProfilesEnabled,
    isApprovalRequired: approvalRequiredFor !== 'none',
    isSaveAndRequestApprovalDisabled: approvalRequiredFor !== 'all',
  }
}
